const stagesTabStyles = (theme) => ({
  container: {
    padding: theme.spacing(3),
  },
  header: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },
  tableContainer: {
    marginTop: theme.spacing(2),
  },
  actionButtons: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  groupsCell: {
    paddingTop: 0,
    paddingBottom: 0,
    backgroundColor: '#f8f9fa',
  },
  groupsContainer: {
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(6),
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    marginLeft: theme.spacing(2),
  },
  groupItem: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    borderRadius: theme.spacing(0.5),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:last-child': {
      marginBottom: 0,
    },
  },
  groupChip: {
    marginLeft: theme.spacing(1),
  },
  expandButton: {
    transition: 'transform 0.2s',
  },
  stageRow: {
    cursor: 'pointer',
  },
})

export default stagesTabStyles
